import React from "react";
import "./assumptions.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import NotFound from "../../atoms/NotFound";
import LoadingSpinner from "../../atoms/Loader";

const CalculatorAssumptionsModal = (props) => {
  const { assumptionsFetch, assumptionsData, assumptionsError } = props;
  return (
    <>
      {assumptionsFetch ? (
        <LoadingSpinner />
      ) : assumptionsError ? (
        <NotFound error={assumptionsError} />
      ) : (
        <>
          <div className="pensionable-edit-close">
            <Icons
              iconname="close-large"
              variant="icon-sixteen-px"
              clickHandler={props.handleCloseButton}
            />
          </div>
          <p className="title">{props.modalTitle}</p>
          <p className="sub-head">{assumptionsData?.properties?.heading}</p>
          <div
            className="sub-description"
            dangerouslySetInnerHTML={{
              __html: assumptionsData?.properties?.content?.markup,
            }}
          ></div>
          <Buttons
            name="Got it!"
            className="primary mt-4"
            handleClick={props.btnGotItHandler}
          />
        </>
      )}
    </>
  );
};

export default CalculatorAssumptionsModal;
